import { render, staticRenderFns } from "./AgeDistributionChart.vue?vue&type=template&id=8dd8db06&scoped=true"
import script from "./AgeDistributionChart.vue?vue&type=script&lang=js"
export * from "./AgeDistributionChart.vue?vue&type=script&lang=js"
import style0 from "./AgeDistributionChart.vue?vue&type=style&index=0&id=8dd8db06&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dd8db06",
  null
  
)

export default component.exports